import repository from "@/api/modules/Accounting/CreditDebitMemo";
import cm_type_repository from "@/api/modules/Accounting/CreditMemoType";
import cm_classification_repository from "@/api/modules/Accounting/CreditMemoClassification";
import dm_type_repository from "@/api/modules/Accounting/DebitMemoType";

export default {
  state: {
    cm_details: [],
    reject_cm: [],
    all_cm: [],
    show_cm: [],
    customer_soas: [],
    customer_payment_detail_files: [],
    credit_memo_files: [],
    debit_memo_files: [],
    dm_details: [],
    reject_dm: [],
    all_dm: [],
    show_dm: [],
    credit_memo_types: [],
    credit_memo_type_status: [],
    credit_memo_classifications: [],
    debit_memo_type: [],
    credit_memo_types_card_total: [],
    approved_printed_from_systems: { data: [], total: 0, summary: { cm_count: 0, total_amount: 0 } },
    linked_customers: [],
    can_approve_credit_memos: false,
    can_exec_approve_credit_memos: false,
    can_approve_debit_memos: false,
    can_exec_approve_debit_memos: false,
    credit_memo_approval_settings: { bypasses: [], accounting_approvers: [], exec_approvers: [], users: [] },
    debit_memo_approval_settings: { bypasses: [], accounting_approvers: [], exec_approvers: [], users: [] },
  },
  getters: {
    // GET_ALL_COST_ITEM: (state) => state.all_cost_item,
    GET_CM_DETAILS: (state) => state.cm_details,
    GET_REJECT_CM: (state) => state.reject_cm,
    GET_ALL_CM: (state) => state.all_cm,
    GET_SHOW_CM: (state) => state.show_cm,
    GET_CUSTOMER_SOAS: (state) => state.customer_soas,
    GET_CUSTOMER_PAYMENT_DETAIL_FILE: (state) => state.customer_payment_detail_files,
    GET_CREDIT_MEMO_FILES: (state) => state.credit_memo_files,
    GET_DEBIT_MEMO_FILES: (state) => state.debit_memo_files,
    GET_DM_DETAILS: (state) => state.dm_details,
    GET_REJECT_DM: (state) => state.reject_dm,
    GET_ALL_DM: (state) => state.all_dm,
    GET_SHOW_DM: (state) => state.show_dm,
    GET_CREDIT_MEMO_TYPES: (state) => state.credit_memo_types,
    GET_CREDIT_MEMO_TYPE_STATUS: (state) => state.credit_memo_type_status,
    GET_CREDIT_MEMO_CLASSIFICATIONS: (state) => state.credit_memo_classifications,
    GET_DEBIT_MEMO_TYPES: (state) => state.debit_memo_type,
    GET_ALL_CREDIT_MEMO_TYPES_CARD_TOTAL: (state) => state.credit_memo_types_card_total,
    GET_APPROVED_PRINTED_FROM_SYSTEMS: (state) => state.approved_printed_from_systems,
    GET_LINKED_CUSTOMERS: (state) => state.linked_customers,
    GET_CAN_APPROVE_CREDIT_MEMOS: (state) => state.can_approve_credit_memos,
    GET_CAN_EXEC_APPROVE_CREDIT_MEMOS: (state) => state.can_exec_approve_credit_memos,
    GET_CAN_APPROVE_DEBIT_MEMOS: (state) => state.can_approve_debit_memos,
    GET_CAN_EXEC_APPROVE_DEBIT_MEMOS: (state) => state.can_exec_approve_debit_memos,
    GET_CREDIT_MEMO_APPROVAL_SETTINGS: (state) => state.credit_memo_approval_settings,
    GET_DEBIT_MEMO_APPROVAL_SETTINGS: (state) => state.debit_memo_approval_settings,
  },
  actions: {
    getCMDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getcmdetails(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("CM_DETAILS", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    creditMemoPrint({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .creditmemoprint(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    approveCreditMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .approvecreditmemo(payload.id, payload.params)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    rejectCreditMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .rejectcreditmemo(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("REJECT_CM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getallcm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_CM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    showCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .showcm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("SHOW_CM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    postCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .postcm(payload.params, payload.config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updatecm(payload.params, payload.config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletecm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    cancelCM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .cancelcm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCustomerSoas({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getcustomersoas(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("CUSTOMER_SOAS", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCustomerPaymentDetailFiles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getcustomerpaymentdetailfiles(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("CUSTOMER_PAYMENT_DETAIL_FILES", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoFiles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getcreditmemofiles(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("CREDIT_MEMO_FILES", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDebitMemoFiles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getdebitmemofiles(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("DEBIT_MEMO_FILES", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCustomerPaymentDetailFile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletecustomerpaymentdetailfile(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCreditMemoFile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletecreditmemofile(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteDebitMemoFile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletedebitmemofile(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    printCreditMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .printcreditmemo(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDMDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getdmdetails(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("DM_DETAILS", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    printDebitMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .printdebitmemo(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    approveDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .approvedm(payload.id, payload.params)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    rejectDebitMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .rejectdm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("REJECT_DM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getalldm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_DM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    showDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .showdm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("SHOW_DM", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    postDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .postdm(payload.params, payload.config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updatedm(payload.params, payload.config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .deletedm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    cancelDM({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .canceldm(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getItemCreditMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getitemcreditmemo(payload.id, payload.params)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getItemDebitMemo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getitemdebitmemo(payload.id, payload.params)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoTypes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getCreditMemoTypes(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_CREDIT_MEMO_TYPES", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoTypeStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getCreditMemoTypeStatus(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_CREDIT_MEMO_TYPE_STATUS", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoType({ commit }, payload) {
      return new Promise((resolve, reject) => {
        cm_type_repository
          .getCreditMemoType(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    postCreditMemoType({ commit }, payload) {
      return new Promise((resolve, reject) => {
        cm_type_repository
          .postCreditMemoType(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    creditMemoClassification({ commit }, payload) {
      return new Promise((resolve, reject) => {
        cm_classification_repository[payload.action](payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDebitMemoType({ commit }, payload) {
      return new Promise((resolve, reject) => {
        dm_type_repository
          .getDebitMemoType(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    postDebitMemoType({ commit }, payload) {
      return new Promise((resolve, reject) => {
        dm_type_repository
          .postDebitMemoType(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDebitMemoTypes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getDebitMemoTypes(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_DEBIT_MEMO_TYPES", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoTypesCardTotal({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getCreditMemoTypesCardTotal(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
              commit("ALL_CREDIT_MEMO_TYPES_CARD_TOTAL", response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    massImportCreditMemos({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .massImportCreditMemos(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    massImportDebitMemos({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .massImportDebitMemos(payload)
          .then((response) => {
            if (response.status == 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getApprovedPrintedFromSystems({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getApprovedPrintedFromSystems(payload)
          .then((response) => {
            if (response.status == 200) {
              commit("APPROVED_PRINTED_FROM_SYSTEMS", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getApprovedPrintedForExport({}, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getApprovedPrintedForExport(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    skipCreditMemo({}, payload) {
      return new Promise((resolve, reject) => {
        repository
          .skipCreditMemo(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCreditMemoItemsFromSystem({}, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getCreditMemoItemsFromSystem(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getLinkedCustomers({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.linked_customers.length > 0) {
          resolve(state.linked_customers);
          return;
        }
        repository
          .getLinkedCustomers()
          .then((response) => {
            if (response.status == 200) {
              commit("LINKED_CUSTOMERS", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchCanApproveCreditMemos({ commit }) {
      return new Promise((resolve) => {
        repository
          .canApproveCreditMemos()
          .then((response) => {
            const canApprove = response.data.can_approve;
            const canExecApprove = response.data.can_exec_approve;
            commit("CAN_APPROVE_CREDIT_MEMOS", canApprove);
            commit("CAN_EXEC_APPROVE_CREDIT_MEMOS", canExecApprove);
            resolve({ can_approve: canApprove, can_exec_approve: canExecApprove });
          })
          .catch(() => {
            commit("CAN_APPROVE_CREDIT_MEMOS", false);
            commit("CAN_EXEC_APPROVE_CREDIT_MEMOS", false);
            resolve({ can_approve: false, can_exec_approve: false });
          });
      });
    },
    fetchCanApproveDebitMemos({ commit }) {
      return new Promise((resolve) => {
        repository
          .canApproveDebitMemos()
          .then((response) => {
            const canApprove = response.data.can_approve;
            const canExecApprove = response.data.can_exec_approve;
            commit("CAN_APPROVE_DEBIT_MEMOS", canApprove);
            commit("CAN_EXEC_APPROVE_DEBIT_MEMOS", canExecApprove);
            resolve({ can_approve: canApprove, can_exec_approve: canExecApprove });
          })
          .catch(() => {
            commit("CAN_APPROVE_DEBIT_MEMOS", false);
            commit("CAN_EXEC_APPROVE_DEBIT_MEMOS", false);
            resolve({ can_approve: false, can_exec_approve: false });
          });
      });
    },
    getCreditMemoApprovalSettings({ commit }) {
      return new Promise((resolve, reject) => {
        repository
          .getCreditMemoApprovalSettings()
          .then((response) => {
            commit("CREDIT_MEMO_APPROVAL_SETTINGS", response.data);
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    getDebitMemoApprovalSettings({ commit }) {
      return new Promise((resolve, reject) => {
        repository
          .getDebitMemoApprovalSettings()
          .then((response) => {
            commit("DEBIT_MEMO_APPROVAL_SETTINGS", response.data);
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    storeCreditMemoApprovalBypass({ commit }, payload) {
      return repository.storeCreditMemoApprovalBypass(payload);
    },
    updateCreditMemoApprovalBypass({ commit }, { id, payload }) {
      return repository.updateCreditMemoApprovalBypass(id, payload);
    },
    destroyCreditMemoApprovalBypass({ commit }, id) {
      return repository.destroyCreditMemoApprovalBypass(id);
    },
    storeCreditMemoApprovalApprover({ commit }, payload) {
      return repository.storeCreditMemoApprovalApprover(payload);
    },
    updateCreditMemoApprovalApprover({ commit }, { id, payload }) {
      return repository.updateCreditMemoApprovalApprover(id, payload);
    },
    destroyCreditMemoApprovalApprover({ commit }, id) {
      return repository.destroyCreditMemoApprovalApprover(id);
    },
    storeDebitMemoApprovalBypass({ commit }, payload) {
      return repository.storeDebitMemoApprovalBypass(payload);
    },
    updateDebitMemoApprovalBypass({ commit }, { id, payload }) {
      return repository.updateDebitMemoApprovalBypass(id, payload);
    },
    destroyDebitMemoApprovalBypass({ commit }, id) {
      return repository.destroyDebitMemoApprovalBypass(id);
    },
    storeDebitMemoApprovalApprover({ commit }, payload) {
      return repository.storeDebitMemoApprovalApprover(payload);
    },
    updateDebitMemoApprovalApprover({ commit }, { id, payload }) {
      return repository.updateDebitMemoApprovalApprover(id, payload);
    },
    destroyDebitMemoApprovalApprover({ commit }, id) {
      return repository.destroyDebitMemoApprovalApprover(id);
    },
  },
  mutations: {
    CM_DETAILS: (state, data) => {
      state.cm_details = data;
    },
    REJECT_CM: (state, data) => {
      state.reject_cm = data;
    },
    ALL_CM: (state, data) => {
      state.all_cm = data;
    },
    SHOW_CM: (state, data) => {
      state.show_cm = data;
    },
    CUSTOMER_SOAS: (state, data) => {
      state.customer_soas = data;
    },
    CUSTOMER_PAYMENT_DETAIL_FILES: (state, data) => {
      state.customer_payment_detail_files = data;
    },
    CREDIT_MEMO_FILES: (state, data) => {
      state.credit_memo_files = data;
    },
    DEBIT_MEMO_FILES: (state, data) => {
      state.debit_memo_files = data;
    },
    DM_DETAILS: (state, data) => {
      state.dm_details = data;
    },
    REJECT_DM: (state, data) => {
      state.reject_dm = data;
    },
    ALL_DM: (state, data) => {
      state.all_dm = data;
    },
    SHOW_DM: (state, data) => {
      state.show_dm = data;
    },
    ALL_CREDIT_MEMO_TYPES: (state, data) => {
      state.credit_memo_types = data;
    },
    ALL_CREDIT_MEMO_TYPE_STATUS: (state, data) => {
      state.credit_memo_type_status = data;
    },
    ALL_CREDIT_MEMO_CLASSIFICATIONS: (state, data) => {
      state.credit_memo_classifications = data;
    },
    ALL_DEBIT_MEMO_TYPES: (state, data) => {
      state.debit_memo_type = data;
    },
    ALL_CREDIT_MEMO_TYPES_CARD_TOTAL: (state, data) => {
      state.credit_memo_types_card_total = data;
    },
    APPROVED_PRINTED_FROM_SYSTEMS: (state, data) => {
      state.approved_printed_from_systems = data;
    },
    LINKED_CUSTOMERS: (state, data) => {
      state.linked_customers = data;
    },
    CAN_APPROVE_CREDIT_MEMOS: (state, data) => {
      state.can_approve_credit_memos = data;
    },
    CAN_EXEC_APPROVE_CREDIT_MEMOS: (state, data) => {
      state.can_exec_approve_credit_memos = data;
    },
    CAN_APPROVE_DEBIT_MEMOS: (state, data) => {
      state.can_approve_debit_memos = data;
    },
    CAN_EXEC_APPROVE_DEBIT_MEMOS: (state, data) => {
      state.can_exec_approve_debit_memos = data;
    },
    CREDIT_MEMO_APPROVAL_SETTINGS: (state, data) => {
      state.credit_memo_approval_settings = data;
    },
    DEBIT_MEMO_APPROVAL_SETTINGS: (state, data) => {
      state.debit_memo_approval_settings = data;
    },
  },
};
